export default __webpack_public_path__ + "static/media/disc-icon.18c6ac70.png";